const es = {
  brand: "E2 Care",
  tagline: "Cuidados tranquilos y conectados.",
  nav_dashboard: "Panel",
  nav_residents: "Pacientes",
  nav_patients: "Pacientes",
  nav_rooms: "Habitaciones",
  nav_devices: "Dispositivos",
  nav_events: "Eventos",
  nav_alerts: "Alertas",
  nav_users: "Equipo",
  nav_settings: "Ajustes",
  nav_admin: "Administración",
  nav_signout: "Cerrar sesión",
  topbar_search_placeholder: "Buscar pacientes, habitaciones, dispositivos…",
  admin_super_only: "Solo los superadministradores pueden gestionar organizaciones.",
  admin_admin_only: "Solo los administradores pueden acceder a esta página.",
  admin_tab_orgs: "Organizaciones",
  admin_tab_users: "Usuarios",
  admin_tab_patients: "Pacientes",
  admin_tab_rooms: "Habitaciones",
  admin_tab_buildings: "Edificios",
  admin_tab_devices: "Dispositivos",
  admin_tab_alerts: "Alertas",
  admin_tab_qa: "Herramientas de prueba",
  admin_delete: "Eliminar",
  admin_no_orgs_yet: "Aún no hay organizaciones.",
  admin_field_name: "Nombre",
  admin_field_email: "Correo electrónico",
  admin_field_phone: "Teléfono",
  admin_field_password: "Contraseña",
  admin_field_role: "Rol",
  admin_field_type: "Tipo",
  admin_field_timezone: "Zona horaria",
  admin_field_address: "Dirección",
  admin_field_status: "Estado",
  admin_field_organization: "Organización",
  admin_password_keep: "Dejar vacío para conservar",
  admin_field_birth_date: "Fecha de nacimiento",
  admin_field_room: "Habitación",
  admin_field_room_none: "Sin asignar",
  admin_field_photo: "URL de la foto",
  admin_field_photo_hint: "Pegue una URL pública — la carga completa llegará en v2.",
  admin_field_notes: "Notas del cuidador",
  admin_field_emergency_contact: "Contacto principal de emergencia",
  admin_field_ec_name: "Nombre",
  admin_field_ec_phone: "Teléfono",
  admin_field_ec_relationship: "Parentesco",
  admin_field_mac: "Dirección MAC",
  admin_field_firmware: "Firmware",
  admin_field_assignment: "Asignado a",
  admin_field_assigned_room: "Habitación asignada",
  admin_field_assigned_patient: "Paciente asignado",
  admin_field_assigned_hint: "Opcional. Sensores → habitación; pulseras → paciente.",
  admin_field_sensor_target: "Montado en",
  admin_field_sensor_target_hint: "Indica al sistema si este sensor vigila una puerta o una ventana.",
  sensor_target_door: "Puerta",
  sensor_target_window: "Ventana",
  sensor_target_unset: "Sin configurar",
  admin_field_sensor_label: "Etiqueta del sensor",
  admin_field_sensor_label_hint: "Nombre descriptivo mostrado en alertas y eventos — p. ej. «Puerta principal», «Ventana del baño».",
  admin_field_building: "Edificio",
  admin_field_building_required: "Una habitación debe pertenecer a un edificio.",
  room_openings: "Aberturas",
  room_no_openings: "Aún no hay sensores de puerta o ventana instalados en esta habitación.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Último cambio",
  admin_field_description: "Descripción",
  admin_field_severity: "Gravedad",
  admin_field_patient: "Paciente",
  admin_field_device: "Dispositivo",
  admin_field_message: "Mensaje",
  admin_orgs_title: "Organizaciones",
  admin_orgs_sub: "Crear, editar y archivar inquilinos de E2 Care.",
  admin_orgs_count: "organizaciones",
  admin_org_new: "Nueva organización",
  admin_org_new_title: "Nueva organización",
  admin_org_edit_title: "Editar organización",
  admin_org_created: "Organización creada.",
  admin_org_updated: "Organización actualizada.",
  admin_org_deleted: "Organización archivada.",
  admin_org_delete_title: "¿Archivar organización?",
  admin_org_delete_confirm: "«{name}» se ocultará de los listados.",
  admin_users_title: "Usuarios",
  admin_users_sub_super: "Gestionar todas las cuentas de usuario en todos los inquilinos.",
  admin_users_sub_org: "Gestionar cuentas de usuario de {org}.",
  admin_user_new: "Nuevo usuario",
  admin_user_new_title: "Nuevo usuario",
  admin_user_edit_title: "Editar usuario",
  admin_user_created: "Usuario creado.",
  admin_user_updated: "Usuario actualizado.",
  admin_user_deleted: "Usuario archivado.",
  admin_user_delete_title: "¿Archivar usuario?",
  admin_user_delete_confirm: "«{name}» perderá el acceso.",
  admin_user_memberships: "Membresías de organización",
  admin_patients_title: "Pacientes",
  admin_patients_sub_super: "Gestionar todos los pacientes en todos los inquilinos.",
  admin_patients_sub_org: "Gestionar pacientes en {org}.",
  admin_patient_new: "Nuevo paciente",
  admin_patient_new_title: "Nuevo paciente",
  admin_patient_edit_title: "Editar paciente",
  admin_patient_created: "Paciente creado.",
  admin_patient_updated: "Paciente actualizado.",
  admin_patient_deleted: "Paciente archivado.",
  admin_patient_delete_title: "¿Archivar paciente?",
  admin_patient_delete_confirm: "«{name}» se ocultará de los listados.",
  admin_rooms_title: "Habitaciones",
  admin_rooms_sub_super: "Configurar habitaciones en todos los inquilinos.",
  admin_rooms_sub_org: "Configurar habitaciones en {org}.",
  admin_room_new: "Nueva habitación",
  admin_room_new_title: "Nueva habitación",
  admin_room_edit_title: "Editar habitación",
  admin_room_created: "Habitación creada.",
  admin_room_updated: "Habitación actualizada.",
  admin_room_deleted: "Habitación archivada.",
  admin_room_delete_title: "¿Archivar habitación?",
  admin_room_delete_confirm: "«{name}» se ocultará.",
  admin_devices_title: "Dispositivos",
  admin_devices_sub_super: "Aprovisionar dispositivos Moko en todos los inquilinos.",
  admin_devices_sub_org: "Aprovisionar dispositivos Moko en {org}.",
  admin_device_new: "Nuevo dispositivo",
  admin_device_new_title: "Nuevo dispositivo",
  admin_device_edit_title: "Editar dispositivo",
  admin_device_created: "Dispositivo creado.",
  admin_device_updated: "Dispositivo actualizado.",
  admin_device_deleted: "Dispositivo archivado.",
  admin_device_delete_title: "¿Archivar dispositivo?",
  admin_device_delete_confirm: "El dispositivo {mac} se ocultará.",
  admin_buildings_title: "Edificios",
  admin_buildings_sub_super: "Agrupar habitaciones por edificio / ala en todos los inquilinos.",
  admin_buildings_sub_org: "Agrupar habitaciones por edificio / ala en {org}.",
  admin_building_new: "Nuevo edificio",
  admin_building_new_title: "Nuevo edificio",
  admin_building_edit_title: "Editar edificio",
  admin_building_created: "Edificio creado.",
  admin_building_updated: "Edificio actualizado.",
  admin_building_deleted: "Edificio archivado.",
  admin_building_delete_title: "¿Archivar edificio?",
  admin_building_delete_confirm: "«{name}» se ocultará.",
  admin_qa_title: "Herramientas de prueba",
  admin_qa_sub: "Inyecte eventos / alertas para probar sin hardware Moko real.",
  admin_qa_event_title: "Inyectar evento de prueba",
  admin_qa_event_sub: "Simula un webhook de Moko.",
  admin_qa_alert_title: "Inyectar alerta de prueba",
  admin_qa_alert_sub: "Omite la capa de eventos y escribe una alerta directamente.",
  admin_qa_inject_event: "Inyectar evento",
  admin_qa_inject_alert: "Inyectar alerta",
  admin_qa_event_done: "Evento inyectado.",
  admin_qa_alert_done: "Alerta inyectada.",
  admin_qa_disclaimer: "Estos endpoints deben deshabilitarse en producción.",
  admin_alerts_title: "Política de alertas",
  admin_alerts_sub: "Reglas de alerta para toda {org}. Se aplican a cada paciente de este inquilino.",
  admin_alerts_quiet_title: "Horas de silencio",
  admin_alerts_quiet_desc: "Define cuándo esta organización está en «modo nocturno». Útil para enviar alertas no críticas de forma más discreta.",
  admin_alerts_quiet_hint: "Las horas se interpretan en la zona horaria local de la organización. El rango puede pasar de medianoche (p. ej. 22:00 → 06:00).",
  admin_alerts_night_start: "La noche empieza",
  admin_alerts_night_end: "La noche termina",
  admin_alerts_load_failed: "Cargar política de alertas",
  admin_alerts_save_failed: "Guardar política de alertas",
  admin_alerts_saved: "Política de alertas guardada.",
  admin_alerts_clear_title: "Borrar alertas activas",
  admin_alerts_clear_desc: "Confirma todas las alertas abiertas de esta organización con un clic.",
  admin_alerts_clear_hint: "Útil tras un simulacro planificado o un sensor mal configurado que generó una oleada de falsos positivos. Las alertas confirmadas permanecen en el historial.",
  admin_alerts_ack_all_button: "Confirmar todas",
  admin_alerts_ack_all_title: "¿Confirmar todas las alertas activas?",
  admin_alerts_ack_all_confirm: "Esto marcará como confirmada cada alerta abierta en {org}. Esta acción no se puede deshacer.",
  admin_alerts_ack_all_done: "{count} alerta(s) confirmada(s).",
  admin_alerts_ack_all_done_generic: "Todas las alertas activas confirmadas.",
  admin_alerts_ack_all_failed: "Confirmar todas las alertas",
  org_type_nursing_home: "Residencia de ancianos",
  org_type_assisted_living: "Vida asistida",
  org_type_hospital: "Hospital",
  org_type_home_care: "Cuidados a domicilio",
  role_admin: "Administrador",
  role_caregiver: "Cuidador",
  role_family: "Familia",
  status_active: "activo",
  status_inactive: "inactivo",
  confirm: "Confirmar",
  sign_in: "Iniciar sesión",
  sign_up: "Registrarse",
  email: "Correo electrónico",
  password: "Contraseña",
  full_name: "Nombre completo",
  create_account: "Crear cuenta",
  no_account: "¿Aún no tienes cuenta?",
  have_account: "¿Ya tienes una cuenta?",
  login_welcome: "Bienvenido de nuevo",
  login_sub: "Inicia sesión para seguir supervisando a tus residentes.",
  register_welcome: "Únete a E2 Care",
  register_sub: "Crea tu espacio de trabajo en menos de un minuto.",
  total_residents: "Pacientes",
  active_devices: "Dispositivos activos",
  open_alerts: "Alertas abiertas",
  offline_gateways: "Dispositivos fuera de línea",
  falls_7d: "Caídas (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Batería baja",
  critical_residents: "Críticos",
  status_ok: "Todo en orden",
  status_warning: "Atención",
  status_critical: "Crítico",
  status_online: "En línea",
  status_offline: "Fuera de línea",
  search: "Buscar",
  filter: "Filtrar",
  all: "Todos",
  refresh: "Actualizar",
  loading: "Cargando…",
  no_results: "Aún no hay nada aquí.",
  view_profile: "Ver perfil",
  showing_n_of_m: "Mostrando {n} de {m}",
  load_more: "Cargar más",
  auto_refresh: "En vivo · auto-actualizar",
  auto_refresh_paused: "Pausado (cargar más activo)",
  updated_just_now: "Actualizado ahora",
  updated_n_sec_ago: "Actualizado hace {n}s",
  updated_n_min_ago: "Actualizado hace {n}m",
  acknowledge: "Confirmar",
  acknowledged: "Confirmado",
  ack_all: "Confirmar todas",
  ack_all_confirm: "¿Confirmar las {count} alerta(s) activa(s)?",
  ack_all_running: "Confirmando…",
  ack_all_done: "{count} alerta(s) confirmada(s).",
  ack_all_partial: "{ok} confirmada(s) · {fail} fallida(s).",
  last_seen: "Visto por última vez",
  battery: "Batería",
  signal: "Señal",
  firmware: "Firmware",
  room: "Apto / Hab.",
  age: "Edad",
  emergency_contact: "Contacto de emergencia",
  notes: "Notas",
  assigned_devices: "Dispositivos asignados",
  recent_events: "Eventos recientes",
  timeline_24h: "Últimas 24 horas",
  delivery_status: "Estado de entrega",
  acknowledged_by: "Confirmado por",
  dashboard_title: "Visión general",
  dashboard_sub: "Una lectura rápida de todo lo que ocurre en las residencias que atiendes.",
  residents_title: "Pacientes",
  residents_sub: "Personas que estás supervisando ahora.",
  devices_title: "Dispositivos",
  devices_sub: "Sensores y pulseras.",
  devices_sub_admin: "Pasarelas, sensores y pulseras.",
  events_title: "Eventos en vivo",
  events_sub: "Flujo cronológico de cada dispositivo conectado.",
  alerts_title: "Alertas",
  alerts_sub: "Notificaciones escaladas a familia y cuidadores.",
  settings_title: "Ajustes",
  settings_sub: "Tus preferencias y reglas de notificación.",
  users_title: "Equipo",
  users_sub: "Cuidadores, familia y administradores con acceso.",
  falls_chart_title: "Caídas y SOS — últimos 7 días",
  recent_alerts_title: "Alertas críticas recientes",
  no_alerts: "No hay alertas abiertas. Todos están a salvo.",
  event_fall: "Caída detectada",
  event_sos: "Botón SOS pulsado",
  event_door_open: "Puerta abierta",
  event_door_close: "Puerta cerrada",
  event_inactivity: "Inactividad prolongada",
  event_low_battery: "Batería baja",
  event_offline: "Dispositivo fuera de línea",
  event_online: "Dispositivo de nuevo en línea",
  event_heartbeat: "Latido",
  event_button_press: "Botón pulsado",
  device_gateway: "Pasarela Bluetooth",
  device_door_sensor: "Sensor de puerta",
  device_bracelet: "Pulsera",
  device_unknown: "Dispositivo desconocido",
  language: "Idioma",
  notifications: "Notificaciones",
  quiet_hours: "Horas de silencio",
  escalation: "Política de escalado",
  just_now: "ahora mismo",
  min_ago: "min",
  h_ago: "h",
  d_ago: "d",
  demo_hint: "Cuenta demo: admin@e2care.lv / Care2024!",
  open_menu: "Abrir menú",
  close_menu: "Cerrar menú",
  care_team: "Equipo de cuidados",
  family_members: "Familia",
  no_caregivers: "Aún no hay cuidadores asignados.",
  no_family: "Aún no hay familiares vinculados.",
  add_caregiver: "Añadir cuidador",
  add_family: "Añadir familiar",
  select_user: "Selecciona un usuario…",
  cancel: "Cancelar",
  add: "Añadir",
  remove: "Quitar",
  save: "Guardar",
  relationship: "Parentesco",
  relationship_son: "Hijo",
  relationship_daughter: "Hija",
  relationship_spouse: "Cónyuge",
  relationship_other: "Otro",
  notify_via: "Notificar vía",
  call_contact: "Llamar",
  view_resident: "Abrir perfil",
  address: "Dirección",
  admin_only_section: "Herramientas de admin",
  rooms_title: "Habitaciones",
  rooms_sub: "Cada habitación que supervisas — pacientes, dispositivos y estado actual.",
  room_name: "Habitación",
  room_type: "Tipo",
  room_type_private_room: "Habitación privada",
  room_type_shared_room: "Habitación compartida",
  room_type_apartment: "Apartamento",
  room_type_corridor: "Pasillo",
  room_type_common_area: "Zona común",
  room_floor: "Planta",
  room_state: "Estado actual",
  door: "Puerta",
  window: "Ventana",
  door_open_state: "Abierta",
  door_closed_state: "Cerrada",
  door_unknown_state: "Desconocido",
  room_no_devices: "Aún no hay dispositivos en esta habitación.",
  room_no_patients: "Aún no hay pacientes asignados a esta habitación.",
  room_patients: "Pacientes en la habitación",
  room_devices: "Dispositivos en la habitación",
  room_activity: "Cronología de actividad",
  rooms_filter_all_types: "Todos los tipos",
  widget_active_alerts: "Alertas activas",
  widget_active_alerts_sub: "Críticas, sin resolver y confirmadas",
  widget_patients_status: "Estado de pacientes",
  widget_devices_health: "Salud de dispositivos",
  widget_room_activity: "Actividad de habitaciones",
  widget_recent_events: "Flujo de eventos en vivo",
  widget_connectivity: "Conectividad",
  metric_critical: "Crítico",
  metric_unresolved: "Sin resolver",
  metric_acknowledged_count: "Confirmados",
  metric_total: "Total",
  metric_active: "Activos",
  metric_online: "En línea",
  metric_offline: "Fuera de línea",
  metric_ota_pending: "OTA pendiente",
  metric_battery_warn: "Batería baja",
  metric_doors_open: "Puertas abiertas",
  metric_windows_open: "Ventanas abiertas",
  metric_signal_avg: "Señal media",
  metric_last_comm: "Última com.",
  metric_packets: "Paquetes / h",
  view_all: "Ver todo",
  status_new: "Nuevo",
  status_acknowledged: "Confirmado",
  status_resolved: "Resuelto",
  status_resolved_local: "Resuelta (local)",
  resolve: "Resolver",
  add_note: "Añadir nota",
  save_note: "Guardar nota",
  resolve_local_badge: "solo este dispositivo",
  resolve_local_hint: "Marca la alerta como resuelta solo en tu navegador. El servidor y otros miembros del equipo la siguen viendo como abierta.",
  note_placeholder: "Añade contexto para el equipo…",
  notes_count: "{n} nota(s)",
  device_detail: "Detalle del dispositivo",
  device_diagnostics: "Diagnóstico",
  device_firmware_history: "Historial de firmware",
  device_ota_config: "Configuración OTA",
  device_ota_status: "Estado OTA",
  device_signal: "Calidad de señal",
  device_mac: "Dirección MAC",
  device_serial: "Número de serie",
  fall_sensitivity: "Sensibilidad de caída",
  transmission_interval: "Intervalo de transmisión",
  low_battery_threshold: "Umbral de batería baja",
  ota_idle: "Inactivo",
  ota_pending: "Pendiente",
  ota_deploying: "Desplegando",
  ota_failed: "Fallido",
  events_filter_severity: "Gravedad",
  events_filter_room: "Habitación",
  events_filter_patient: "Paciente",
  events_filter_device: "Dispositivo",
  severity_info: "Info",
  severity_warning: "Advertencia",
  severity_critical: "Crítico",
  telegram_title: "Alertas de Telegram",
  telegram_desc: "Recibe alertas de Telegram para los residentes que tienes asignados.",
  telegram_connect: "Conectar Telegram",
  telegram_connected: "Telegram conectado",
  telegram_connected_as: "Conectado a Telegram como {name}",
  telegram_connect_success: "Telegram conectado correctamente",
  telegram_connect_error: "No se pudo conectar Telegram. Inténtalo de nuevo.",
  telegram_missing_bot: "Bot de Telegram no configurado. Define REACT_APP_TELEGRAM_BOT en el archivo env.",
  telegram_disconnect: "Desconectar",
  telegram_disconnect_success: "Telegram desconectado.",
  telegram_disconnect_error: "No se pudo desconectar Telegram. Inténtalo de nuevo.",
  telegram_already_linked: "Esta cuenta de Telegram ya está vinculada a otro usuario de e2-care.",
  telegram_switch_q: "¿Usar otra cuenta de Telegram?",
  telegram_switch_intro: "Telegram recuerda qué cuenta está conectada en todos los sitios web. Para usar otra:",
  telegram_switch_step1: "Abre Telegram Web y cierra la sesión de tu cuenta actual.",
  telegram_switch_step2: "Vuelve aquí y recarga el botón de abajo, luego inicia sesión con la otra cuenta.",
  telegram_open_web: "Abrir Telegram Web",
  telegram_reload_widget: "Cerré sesión — recargar el botón",
  lang_autodetected_toast: "Idioma detectado: {language}. Puedes cambiarlo en Ajustes.",
  admin_view_active: "Activos",
  admin_view_archived: "Archivados",
  admin_restore: "Restaurar",
  admin_restored: "Restaurado.",
  admin_hard_delete: "Eliminar definitivamente",
  admin_hard_delete_title: "¿Eliminar definitivamente?",
  admin_hard_delete_confirm: "«{name}» se eliminará definitivamente de la base de datos. Esta acción no se puede deshacer.",
  admin_hard_deleted: "Eliminado definitivamente.",
  admin_no_archived: "No hay elementos archivados.",
  language_desc: "Se usa para la interfaz de la aplicación y tus notificaciones de Telegram + push.",
  language_saved: "Idioma actualizado.",
  language_error: "No se pudo actualizar el idioma. Inténtalo de nuevo.",
  admin_field_language: "Idioma",
  edit: "Editar",
  generic_error: "Algo salió mal. Inténtalo de nuevo.",
  caregiver_added: "Cuidador añadido.",
  caregiver_removed: "Cuidador eliminado.",
  family_added: "Familiar añadido.",
  family_removed: "Familiar eliminado.",
  menu: "Menú",
  dl_companion_app: "Aplicación complementaria",
  dl_hero_title: "E2 Care para Android",
  dl_hero_sub: "Instala la aplicación complementaria en un teléfono con Moko para retransmitir alertas, configurar dispositivos y mantenerte conectado con tu equipo de cuidado, incluso cuando el panel está cerrado.",
  dl_android_apk: "APK de Android",
  dl_version_loading: "cargando versión…",
  dl_released: "Publicado el {date}",
  dl_download_apk: "Descargar APK",
  dl_unavailable: "No disponible",
  dl_preparing: "Preparando…",
  dl_manifest_error: "No se pudo cargar el manifiesto. Intenta actualizar; si el problema persiste, el servidor de compilación puede estar redesplegándose.",
  dl_whats_new: "Novedades",
  dl_installing_title: "Instalación en tu teléfono",
  dl_step1: "Toca «Descargar APK» arriba. Tu navegador puede advertir que los archivos APK pueden dañar tu dispositivo; esa advertencia es normal para cualquier instalador descargado fuera de Play Store.",
  dl_step2: "Abre el archivo descargado. Android te pedirá permitir instalaciones desde este navegador la primera vez; activa el permiso y vuelve.",
  dl_step3: "Toca «Instalar» y luego «Abrir» cuando termine.",
  dl_step4: "Inicia sesión con tus credenciales de E2 Care.",
  dl_iphone_note: "La versión para iPhone llegará más adelante. Por ahora, usa el panel web.",
  dl_back_to_dashboard: "Volver al panel",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Cambiar de organización borra la asignación actual de habitación y paciente.",
  admin_view_full: "Lista completa",
  device_filter_assignment: "Asignación",
  device_filter_patient: "Asignado a paciente",
  device_filter_room: "Asignado a habitación",
  device_filter_unassigned: "Sin asignar",
  admin_all_orgs: "Todas las organizaciones",
  pagination_prev: "Anterior",
  pagination_next: "Siguiente",
  pagination_per_page: "Por página",
  pagination_page_of: "Página {page} de {pages}",
  pagination_total: "{total} en total",
};
export default es;
